// import react packages;
import React, { useContext } from "react";

// import hoc
import { withErrorBoundary, withFeature } from "lib/hoc";

// Import Polaris Components
import { Card, TextContainer } from "@shopify/polaris";

// import helper
import { PrivateContext } from "lib/context";
import constant from "lib/constant/constant";

// import components
import MagentoConnect from "app/product/modules/provider/features/genric/magentoConnect/magentoConnect";

const VendorConnectMagento = (prop) => {
  const { cms } = useContext(PrivateContext);
  const { setBanner } = prop;

  return (
    <>
      <Card title={cms("section.connect.title")}>
        <Card.Section>
          <TextContainer>{cms("section.connect.description")}</TextContainer>
          <br />
          <MagentoConnect setBanner={setBanner} />
        </Card.Section>
      </Card>
    </>
  );
};

export default withFeature(withErrorBoundary(VendorConnectMagento), {
  feature: constant.PRODUCT_IMPORT_WOOCOMMERCE,
  // subFeature: constant.PRODUCT_IMPORT_WOOCOMMERCE,
});
